import { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm'

type ResultProps = {
	id: string;
}

const Result = (props: ResultProps) => {

	const [result, setResult] = useState({diagnosis: '' as string});
	
	fetch(`https://orthopedics-diagnosis.com/diagnosis/api/result/${props.id}`)
		.then(res => res.json())
		.then(
			(result) => {
				setResult(result);
			},
			(error) => {
			}
		);

	return (
		<>
			<div className="row">
				<div className="col-md-12 pages_area">
					<h1>診断結果</h1>
			        <ReactMarkdown children={result.diagnosis} remarkPlugins={[gfm]}  />
					<div className="mt-5">
						<a href="/" className="btn btn-secondary" style={{ textDecoration: 'none', color: '#fff'}} >トップへ戻る</a>
					</div>
				</div>
			</div>
		</>
	);
};

export { Result };
